import React, { useEffect, useState, useRef } from 'react'
import { X } from '@phosphor-icons/react'

export default function Toast({ message, type = 'info', duration = 3000, onClose }) {
  const [visible, setVisible] = useState(true)
  const onCloseRef = useRef(onClose)

  useEffect(() => {
    onCloseRef.current = onClose
  }, [onClose])

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false)
      onCloseRef.current && onCloseRef.current()
    }, duration)

    return () => clearTimeout(timer)
  }, [duration])

  if (!visible) return null

  const typeClasses = {
    success: 'alert-success',
    error: 'alert-error',
    warning: 'alert-warning',
    info: 'alert-info',
  }

  return (
    <div className="toast toast-top toast-end z-50">
      <div className={`alert ${typeClasses[type]}`}>
        <span>{message}</span>
        <button
          onClick={() => {
            setVisible(false)
            onCloseRef.current && onCloseRef.current()
          }}
          className="btn btn-sm btn-circle btn-ghost"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  )
}
